module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE4LjkgMzUuOTVRMTguNDUgMzUuOTUgMTguMDI1IDM1Ljc3NVExNy42IDM1LjYgMTcuMjUgMzUuMjVMOC4yIDI2LjJRNy41IDI1LjUgNy41IDI0LjVRNy41IDIzLjUgOC4yIDIyLjhROC45IDIyLjEgOS44NzUgMjIuMVExMC44NSAyMi4xIDExLjYgMjIuOEwxOC45IDMwLjFMMzYuNCAxMi42NVEzNy4xIDExLjk1IDM4LjA3NSAxMS45MjVRMzkuMDUgMTEuOSAzOS43NSAxMi42NVE0MC40NSAxMy4zNSA0MC40NSAxNC4zNVE0MC40NSAxNS4zNSAzOS43NSAxNi4wNUwyMC41NSAzNS4yNVEyMC4yIDM1LjYgMTkuNzc1IDM1Ljc3NVExOS4zNSAzNS45NSAxOC45IDM1Ljk1WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-done.svg
// module id = 0
// module chunks = 0